import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useDiscountTagStyles = makeStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#E8FDEE',
        fontSize: tokens.fontSizeBase300,
        lineHeight: '20px',
        color: '#212121',
        ...shorthands.padding(tokens.spacingVerticalM),
        ...shorthands.borderRadius(tokens.borderRadiusLarge)
    },
    tagIcon: {
        color: '#198038',
        fontSize: tokens.fontSizeHero700
    },
    singleMessage: {
        marginLeft: tokens.spacingHorizontalM
    },
    messageList: {
        marginLeft: '-15px'
    }
});
